<script>
import ListEvaluationsComponent from '../../features/lists/ListEvaluationsComponent';
import ModalEvaluationView from '../modals/ModalEvaluationView';

export default {
  name: 'ListEvaluationView',
  components: {
    'modal-evaluation-view': ModalEvaluationView,
  },
  extends: ListEvaluationsComponent,
};
</script>
<template>
  <div class="list-body">
    <el-row
      :gutter="20"
      class="section-ctrl"
    >
      <el-col
        :xs="24"
        :sm="13"
        :md="14"
        :lg="9"
        :xl="7"
        class="header-right"
      >
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Evaluación
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <!--
              <el-dropdown-item>
                <el-button
                  size="small"
                  class="btn-primary-light"
                  icon="el-icon-upload"
                  @click="onShowImport"
                  :disabled="!onCanCreate(modulePermissions)"
                  >Importar Evaluaciones</el-button
                >
              </el-dropdown-item>
              -->
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.courseFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Curso..."
                    :remote-method="onSearchCourse"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.courseFilter.id, 'CourseId')"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in courses"
                      :key="item.id"
                      :label="item.title"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.studentFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Estudiantes..."
                    :remote-method="onSearchStudent"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.studentFilter.id, 'StudentId')"
                    @focus="onFocus"
                  >
                    <el-option
                      v-for="item in students"
                      :key="item.id"
                      :label="mapStudentName(item)"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
      </el-col>
      <el-col
        :xs="24"
        :sm="7"
        :md="7"
        :lg="5"
        :xl="8"
      >
        <el-button-group>
          <el-button
            type="info"
            size="small"
            class="btn-cancel btn-rate"
          >
            <el-rate
              v-model="filterOptions.qualificationFilter"
              class="size-star"
              text-color="#909399"
              score-template="Calificación"
              clearable
              @change="onAllFilterChange(filterOptions.qualificationFilter, 'Qualification')"
              @focus="onFocus"
            />
          </el-button>
          <el-button
            type="info"
            size="small"
            class="btn-cancel"
            @click="onClearQualification"
          >
            X
          </el-button>
        </el-button-group>
      </el-col>
    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label=""
        width="70"
      >
        <template #default="scope">
          <div>
            <el-avatar :src="mapProfileImage(scope.row.student?.userProfile)" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="ESTUDIANTE"
        min-width="250"
      >
        <template #default="scope">
          <div>
            {{ mapStudentName(scope.row.student) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="CALIFICACIÓN"
        align="center"
        width="130"
      >
        <template #default="scope">
          <div>
            <el-rate
              v-model="scope.row.qualification"
              disabled
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="CURSO"
        min-width="250"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.course }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="REGISTRO"
        text-align="center"
        align="center"
        width="170"
      >
        <template #default="scope">
          <div>
            <el-tag type="success">
              {{ formatDate(scope.row.createdAt) }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="OPCIONES"
        :width="160"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-evaluation-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
  </div>
</template>